const setConfigurations = (state, configurations) => {
  state.configurations = configurations
}

const setToken = (state, token) => {
  state.token = token
}

const setHashToken = (state, hashToken) => {
  state.hashToken = hashToken
}

export default {
  setConfigurations,
  setToken,
  setHashToken
}
